import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { deserializer } from '@shared/helpers/deserializer.helper';
import { errorHandler } from '@shared/helpers/handle-error.helper';
import { IDocument } from '@shared/interfaces/document.interface';
import { IIssue } from '@shared/interfaces/issue.interface';
import { IPaginable } from '@shared/interfaces/paginable.interface';
import { Issue } from '@shared/models/issue.model';
import { IssuesSerializer } from '@shared/serializers/issues.serializer';
import { CommonEnvironmentsService } from '@shared/services/environments.service';
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IssuesService implements IPaginable {
  private readonly endpoint: string = String(
    `${this._commonEnvironments.API_ENDPOINT}/issues`
  );

  constructor(
    private readonly _commonEnvironments: CommonEnvironmentsService,
    private readonly _http: HttpClient
  ) { }

  public delete(id: string): Observable<IIssue> {
    return this._http.delete(`${this.endpoint}/${id}`).pipe(
      map((res: any) => new Issue(deserializer.deserialize(res))),
      catchError(errorHandler)
    );
  }

  public find(id: string): Observable<IIssue> {
    return this._http.get(`${this.endpoint}/${id}`).pipe(
      map((res: any) => new Issue(deserializer.deserialize(res))),
      catchError(errorHandler)
    );
  }

  public get(
    pageNumber?: number,
    filters?: any,
    onGetRawData?: (data: any) => void
  ): Observable<IIssue[]> {
    let httpParams = new HttpParams();

    if (pageNumber) {
      httpParams = httpParams.set('page[number]', String(pageNumber));
    }

    if (filters) {
      filters.map((f) => {
        if (f.value) {
          httpParams = httpParams.append(f.key, f.value);
        }
      });
    }

    return this._http.get(this.endpoint, { params: httpParams }).pipe(
      tap((data: any) => onGetRawData && onGetRawData(data)),
      map((res: any) =>
        deserializer.deserialize(res).map((a: IIssue) => new Issue(a))
      ),
      catchError(errorHandler)
    );
  }

  public patch(a: Partial<IIssue>): Observable<IIssue> {
    const data = IssuesSerializer.serialize({
      ...a
    });

    return this._http.patch(`${this.endpoint}/${a.id}`, data).pipe(
      map((res: any) => new Issue(deserializer.deserialize(res))),
      catchError(errorHandler)
    );
  }

  public post(a: IIssue): Observable<IIssue> {
    const data = IssuesSerializer.serialize(a);
    return this._http.post(this.endpoint, data).pipe(
      map((res: any) => new Issue(deserializer.deserialize(res))),
      catchError(errorHandler)
    );
  }

  public importCsv(data: any): Observable<IIssue> {
    return this._http.post(this.endpoint + '/import', data).pipe(
      map((res: any) => res),
      catchError(errorHandler)
    );
  }

}

